// When a release has no image for the requested variant (common for SFW
// thumbs and posters), the API still signs a URL — it just comes back
// path-less, e.g. "https://cdn-images…/?imgw=970&imgh=545", which the CDN
// answers with a 403. Treat that, and a missing URL, as "no image".
//
// Relative URLs resolve against `base`; without one they are not usable.
export const isUsableImageUrl = (url, base) => {
  if (!url) return false

  try {
    return new URL(url, base).pathname !== "/"
  } catch {
    return false
  }
}
